<template>
 <div>
    <header>
      
    </header>
</div>
</template>

<script>
export default {
    name: 'HeaderElem'
}
</script>

